import React from 'react';

import { withStyles, createStyleSheet } from 'material-ui/styles';
import { Route } from 'react-router-dom';
import { Grid } from 'components';

import ToolRoutes from './Tool/Routes';
import StackRoutes from './Stack/Routes';

const styleSheet = createStyleSheet('Main', theme => ({
  main: {
    padding: '8px 16px',
    marginTop: 112,
    // [theme.breakpoints.up('sm')]: {
    //   marginTop: 120,
    // },
  },
}));

const RootRoutes = ({ classes }) => {
  return (
    <Grid container component="main" className={classes.main}>
      <Route component={StackRoutes} />
      <Route component={ToolRoutes} />
    </Grid>
  );
};

export default withStyles(styleSheet)(RootRoutes);



// WEBPACK FOOTER //
// ./src/App/RootRoutes.js